import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from '../messages';

const styles = cssMap({
	footer: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type CardFooterProps = {
	onConfirm: () => Promise<void>;
	isDisabled: boolean;
	isSubmitting: boolean;
	buttonLabel?: string;
};

export const CardFooter = ({
	onConfirm,
	isDisabled,
	isSubmitting,
	buttonLabel,
}: CardFooterProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const idleButtonLabel = buttonLabel ?? formatMessage(messages.buildButtonLabel);

	return (
		<Box xcss={styles.footer}>
			<Button appearance="primary" onClick={onConfirm} isDisabled={isDisabled}>
				{isSubmitting ? formatMessage(messages.buildingButtonLabel) : idleButtonLabel}
			</Button>
		</Box>
	);
};
